export enum DateTime {
    DEFAULT_TIMER_FORMAT = 'hMS',
    TIMER_LONG_FORMAT = 'hM',
    TIME_FORMAT = 'HH:mm',
    DATE_FORMAT = 'yyyy-MM-dd',
    LONG_DATE_FORMAT = 'dd MMM yyyy',
    LONG_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm',
    DATE_FORMAT_MONTH_DAY = 'MMM d',
}
